import { render } from "./confirm_email.vue?vue&type=template&id=6f597664"
import script from "./confirm_email.vue?vue&type=script&lang=js"
export * from "./confirm_email.vue?vue&type=script&lang=js"
script.render = render

export default script